@if (isLoading()) {
  <ziro-loading-block></ziro-loading-block>
} @else {
  @if (!!autoAttendantView()) {
    <ziro-collapsible-section-card
      data-automation="general-settings-form"
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;admin.teams_voice_management.teams_auto_attendant.general_settings.title.label'"
    >
      <div class="row text-muted small">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <ziro-text [fieldId]="'name'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-md-8">
              <ziro-select [fieldId]="'resourceAccounts'" [inlineLabel]="false"></ziro-select>
            </div>
          </div>
          <div class="row d-flex">
            <ziro-select [fieldId]="'timezone'" [inlineLabel]="false" class="col-3"></ziro-select>
            <ziro-select [fieldId]="'language'" [inlineLabel]="false" class="col-3"></ziro-select>
            <ziro-select [fieldId]="'operatorType'" [inlineLabel]="false" class="col-3"></ziro-select>
            <ziro-text
              [fieldId]="'destinationNumber'"
              [inlineLabel]="false"
              class="col-3"
              [hidden]="formData.operatorType?.value !== AutoAttendantOperatorType.EXTERNAL_PHONE_NUMBER"
            ></ziro-text>
            <ziro-select [fieldId]="'destination'" [inlineLabel]="false" class="col-3"></ziro-select>
          </div>
        </div>
      </div>
    </ziro-collapsible-section-card>

    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <div class="d-flex justify-content-between auto-attendant-row">
        <!-- Auth Users -->
        <div class="auto-attendant-authorized-users d-flex align-items-center gap-2 flex-grow-1 min-w-0">
          <span class="fw-bolder small flex-shrink-0">
            {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.authorized_users.label' | translate }}
          </span>

          @if (localAuthorizedUsers().length) {
            <div class="d-flex align-items-center ms-1 flex-shrink-0">
              @for (user of localAuthorizedUsers().slice(0, 3); track user.guid) {
                <div
                  class="me-2"
                  [ngbTooltip]="user.displayName"
                  [attr.data-automation]="'authorized-user-avatar-' + user.guid"
                >
                  @if (user.photoBase64) {
                    <img [src]="'data:image/png;base64,' + user.photoBase64" class="authorized-user-pic" />
                  } @else if (user.displayName) {
                    <span class="initials initials-letterspacing-2">
                      <strong>{{ getUserInitials(user.displayName) }}</strong>
                    </span>
                  } @else {
                    <i class="fa fa-2x display-pic-size no-user-icon" [class]="ZiroIcons.CIRCLE_USER"></i>
                  }
                </div>
              }
            </div>
          } @else {
            <span class="text-muted small">
              {{
                'tkey;admin.teams_voice_management.teams_auto_attendant.authorized_users.no_users_configured'
                  | translate
              }}
            </span>
          }

          <ziro-button
            [class]="'me-2 flex-shrink-0'"
            [dataAutomation]="'auto-attendant-authorized-users-edit-button'"
            [label]="'tkey;admin.teams_voice_management.teams_auto_attendant.edit_button.label'"
            [isDisabled]="isSubmitting"
            [icon]="ZiroIcons.EDIT"
            [buttonSize]="ButtonSizes.XSMALL"
            [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
            (click)="openAuthorizedUsersModal()"
          ></ziro-button>
        </div>

        <!-- Dial Scope -->
        <div class="auto-attendant-dial-scope d-flex align-items-center gap-2 flex-shrink-1 min-w-0">
          <span class="fw-bolder small flex-shrink-0">
            {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.dial_scope.label' | translate }}
          </span>

          <span class="text-muted small text-truncate min-w-0" data-automation="dial-scope-description">
            {{ getDialScopeDescription() }}
          </span>

          <ziro-button
            [class]="'me-2 flex-shrink-0'"
            [dataAutomation]="'auto-attendant-dial-scope-edit-button'"
            [label]="'tkey;admin.teams_voice_management.teams_auto_attendant.edit_button.label'"
            [icon]="ZiroIcons.EDIT"
            [buttonSize]="ButtonSizes.XSMALL"
            (clicked)="openDialScopeModal()"
            [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
            [tooltip]="'tkey;admin.teams_voice_management.teams_auto_attendants.coming_soon.tooltip' | translate"
            [isTooltipDisabled]="false"
          ></ziro-button>
        </div>
      </div>
    </ziro-collapsible-section-card>

    <ziro-teams-auto-attendants-call-flow
      [isDisabled]="isSubmitting"
      [tenantId]="tenantId()"
      [standardCallFlows]="standardCallFlows"
      [holidayCallFlows]="holidayCallFlows"
      [allHolidays]="autoAttendantsHolidays()"
      (greetingUpdate)="onCallFlowGreetingUpdate($event)"
      [references]="references()"
      [isLoadingReferences]="isLoadingReferences()"
    ></ziro-teams-auto-attendants-call-flow>
  }
}
